import { FloatingPresenceParam } from './floating-presence-param';

export class FloatingPresence {
  subdomain: string;
  country: string;
  websiteId: number;
  params: { [key: string]: FloatingPresenceParam };
}
